/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { compareDependencies } from './dependenciesCompare.generated';
import { isNaNDependencies } from './dependenciesIsNaN.generated';
import { isNumericDependencies } from './dependenciesIsNumeric.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createPartitionSelect } from '../../factoriesAny.js';
export var partitionSelectDependencies = {
  compareDependencies: compareDependencies,
  isNaNDependencies: isNaNDependencies,
  isNumericDependencies: isNumericDependencies,
  typedDependencies: typedDependencies,
  createPartitionSelect: createPartitionSelect
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesPartitionSelect.generated.js
// module id = 332
// module chunks = 0